enum FormFields {
  Avatar = 'avatar',
  AgencyName = 'agencyName',
  AgencyWebsite = 'agencyWebsite',
  ShortDescription = 'shortDescription',
  Place = 'place',
  Radius = 'radius',
  MinPropertyPrice = 'minPropertyPrice',
  MaxPropertyPrice = 'maxPropertyPrice',
  AnyPrice = 'anyPrice',
  BuildingTypes = 'buildingTypes',
  LicenseJurisdictionCode = 'licenseJurisdictionCode',
}

const FormFieldsList = [
  FormFields.Avatar,
  FormFields.AgencyName,
  FormFields.AgencyWebsite,
  FormFields.ShortDescription,
  FormFields.Place,
  FormFields.Radius,
  FormFields.MinPropertyPrice,
  FormFields.MaxPropertyPrice,
  FormFields.BuildingTypes,
  FormFields.LicenseJurisdictionCode,
];

export { FormFields, FormFieldsList };
